import * as Actions from '../actions';

const initialState = {
    sekolah : {},
    sekolah_binaan : []
};

const sekolahReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_SEKOLAH:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                sekolah: action.payload
            };
        }
        case Actions.GET_SEKOLAH_BINAAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                sekolah_binaan: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

export default sekolahReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/Sekolah.reducers.js